import { createFileRoute } from '@tanstack/react-router'
import { GroupScreen } from '@/components/groups/group-screen'
import { BrowserSkeleton, ViewBarSkeleton } from '@/components/shell/screen-skeletons'

export const Route = createFileRoute('/o/$org/groups/$id')({
  pendingComponent: () => (
    <>
      <ViewBarSkeleton />
      <BrowserSkeleton />
    </>
  ),
  component: GroupRoute,
})

function GroupRoute() {
  const { id } = Route.useParams()
  return <GroupScreen groupId={id} />
}
